(function () {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  };

  ready(() => {
    const sticky = document.querySelector('#lumin-sticky-atc');
    if (!sticky) return;

    const variantsScript = sticky.querySelector('[data-cp-sticky-variants]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
    const priceEl = sticky.querySelector('[data-cp-sticky-price]');
    const compareEl = sticky.querySelector('[data-cp-sticky-compare]');
    const offEl = sticky.querySelector('[data-cp-sticky-off]');
    const installmentEl = sticky.querySelector('[data-cp-sticky-installment]');
    const pixEl = sticky.querySelector('[data-cp-sticky-pix]');
    const submitButton = sticky.querySelector('[data-cp-sticky-submit]');
    const imageEl = sticky.querySelector('.cp-product-sticky__image');
    const offset = Number(sticky.dataset.offset || 0);
    let currentVariantId = Number(sticky.dataset.currentVariantId || 0);
    let lastY = window.scrollY;

    const money = (cents) => {
      const value = Number(cents || 0) / 100;
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const findMainButton = () => document.querySelector('main #BtnCulturaPuff')
      || document.querySelector('main .btn-cultura-moderno')
      || document.querySelector('main button[name="add"]:not(.cp-product-sticky__button)')
      || document.querySelector('main .product-form__submit');

    const findVariantInput = () => Array.from(document.querySelectorAll('main [name="id"]'))
      .find((input) => !sticky.contains(input));

    const setHidden = (element, hidden) => {
      if (!element) return;
      element.classList.toggle('is-hidden', hidden);
    };

    const variantById = (id) => variants.find((variant) => Number(variant.id) === Number(id));

    const updateVariant = (variant) => {
      if (!variant) return;

      currentVariantId = Number(variant.id);
      sticky.dataset.currentVariantId = String(currentVariantId);

      const price = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || 0);
      const hasDiscount = compare > price;
      const pix = price * 0.95;
      const installment = (price * 1.2211) / 12;

      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) compareEl.textContent = money(compare);
      if (offEl && hasDiscount) {
        offEl.textContent = `-${Math.round(((compare - price) * 100) / compare)}% OFF`;
      }
      if (installmentEl) installmentEl.textContent = money(installment);
      if (pixEl) pixEl.textContent = money(pix);
      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available ? 'Comprar' : 'Esgotado';
      }
      if (imageEl && variant.featured_image && variant.featured_image.src) {
        imageEl.src = variant.featured_image.src;
        imageEl.srcset = '';
      }

      setHidden(compareEl, !hasDiscount);
      setHidden(offEl, !hasDiscount);
    };

    const selectedVariant = () => {
      const input = findVariantInput();
      const id = input ? Number(input.value) : currentVariantId;
      return variantById(id) || variantById(currentVariantId) || variants[0];
    };

    const refreshFromPage = () => {
      updateVariant(selectedVariant());
    };

    const showSticky = (visible) => {
      sticky.classList.toggle('show', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (window.matchMedia('(max-width: 749px)').matches) {
        document.documentElement.style.paddingBottom = visible ? `${sticky.offsetHeight + 12}px` : '';
      } else {
        document.documentElement.style.paddingBottom = '';
      }
    };

    const updateVisibility = () => {
      const mainButton = findMainButton();
      const triggerBottom = mainButton
        ? mainButton.getBoundingClientRect().bottom + window.scrollY + offset
        : 520;
      const footer = document.querySelector('footer, .shopify-section-group-footer-group');
      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const goingDown = window.scrollY >= lastY;
      const pastButton = window.scrollY > triggerBottom;
      const nearFooter = footerTop < window.innerHeight + 80;

      showSticky(pastButton && !nearFooter && (goingDown || window.scrollY > triggerBottom + 120));
      lastY = window.scrollY;
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches('[name="id"]') && !sticky.contains(target)) {
        updateVariant(variantById(target.value));
      }
    });

    if (submitButton) {
      submitButton.addEventListener('click', () => {
        const mainButton = findMainButton();
        if (mainButton && !mainButton.disabled) {
          mainButton.click();
        }
      });
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    document.addEventListener('variant:change', refreshFromPage);

    setInterval(refreshFromPage, 700);
    refreshFromPage();
    updateVisibility();
  });
})();
